import "./generate_button.css";

function GenerateButton({ onClick, label = "Générer" }) {

  return (
    <div className="button_generate">
      <button onClick={onClick}>
        {label}
      </button>
    </div>
  );
}

export default GenerateButton;